import React from 'react'
import './product-list.less'
import { Button, List, Toast, PullToRefresh, ActivityIndicator } from 'antd-mobile'
import Checkbox from '@/components/checkbox/checkbox'
import Goods from '@/pages/shopping-car/goods/goods'
import { addGood as addGoodApi, delGood as delGoodApi } from '@/api/store'
import Empty from '../empty/empty'
import ReactDOM from 'react-dom'
import { fetchShopingCar, clearCarApi } from '@/api/shopping-car'
import { SET_COUPON_NO } from '@/action-types/shopping-car'
import { connect } from 'react-redux'
import * as util from '@/util/util'
import { setHeader } from '@/util/set-header'
import { goodStorage } from '@/util/good-storage'
const APullToRefresh: any = PullToRefresh
const Item = List.Item
interface Props {
  depot_id: string
}

const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  setCouponNoAction: (coupon_no: any) =>
    dispatch({ type: SET_COUPON_NO, coupon_no }),
})
@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
class ProductList extends React.Component<any, any> {
  private allIdList: string[] = []
  private buyinfo: {}[] = []
  ptr!: PullToRefresh
  constructor(props: any) {
    super(props)
    this.state = {
      list: [],
      refreshing: false,
      checkedIdList: [],
      checkAll: true,
      //总金额
      totalAmount: 0,
      is_rest: false,
      height: document.documentElement.clientHeight,
      isLoading: false
    }
    this.onRefresh = this.onRefresh.bind(this)
  }

  UNSAFE_componentWillMount() {
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false)
    }
    setHeader({ title: '购物袋' })
  }

  componentDidMount() {
    const { depot_id } = this.props
    if (depot_id) {
      this.getGoods(depot_id)
    }
    const height =
      (ReactDOM.findDOMNode(this.ptr) as any).offsetTop +
      (document.querySelector('.navbar-bot') as any).clientHeight

    this.setState({
      height,
    })
  }
  componentWillReceiveProps(nextProps: Props) {
    const nextDepotId = nextProps.depot_id
    const { depot_id } = this.props

    if (depot_id !== nextDepotId) {
      this.getGoods(nextDepotId)
    }
  }
  //获取列表数据
  getGoods = async (depot_id: any) => {
    this.setState({ isLoading: true })
    let { data } = await fetchShopingCar(depot_id)
    if (data.code === 'SUCCESS') {
      const list = data.data.list
      this.allIdList = []
      list.forEach((item: any) => {
        if (item.num !== '0') {
          this.allIdList.push(item.goods_id)
        }
      })

      await this.setState({
        list: list,
        is_rest: data.data.depot.is_rest,
        checkedIdList: [...this.allIdList],
        isLoading: false,
        checkAll: true
      })
      this.calculatedTotal([...this.allIdList], list)

    } else {
      Toast.info(data.msg, 1)
    }
  }
  //下拉刷新
  async onRefresh() {
    this.setState({ refreshing: true })
    let { depot_id } = this.props
    await this.getGoods(depot_id)
    this.setState({ refreshing: false })
  }

  checkChange = async (checked: boolean, id: string) => {
    const { checkedIdList } = this.state
    if (checked) {
      checkedIdList.push(id)
    } else {
      checkedIdList.splice(checkedIdList.indexOf(id), 1)
    }
    await this.setState({
      checkedIdList,
      checkAll: checkedIdList.length === this.allIdList.length,
    })

    this.calculatedTotal(checkedIdList, this.state.list)
  }
  onCheckAllChange = (checked: boolean) => {
    let checkedIdList = checked ? [...this.allIdList] : []
    this.setState({
      checkedIdList: checkedIdList,
      checkAll: checked,
    })

    this.calculatedTotal(checkedIdList, this.state.list)
  }

  //添加商品
  increaseGood = async (goods_id: string) => {

    const { calculatedTotal, state } = this;
    const { depot_id } = this.props
    Toast.loading('加载中', 0)
    const { data } = await addGoodApi({ depot_id, id: goods_id })

    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const { list } = state
    list.forEach((item: any, index: any) => {
      if (item.goods_id === goods_id) {
        list[index].num = parseInt(list[index].num) + 1
      }
    })
    goodStorage.increment(goods_id)
    calculatedTotal(state.checkedIdList, list)
    //  setState({ list })
  }
  //删减商品
  decreaseGood = async (goods_id: string) => {
    const { depot_id } = this.props
    const { state, calculatedTotal } = this
    Toast.loading('加载中', 0)
    const { data } = await delGoodApi({ depot_id, id: goods_id })
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    let { list, checkedIdList } = state

    list.forEach((item: any, index: any) => {
      if (item.goods_id === goods_id) {
        list[index].num = parseInt(list[index].num) - 1
        if (list[index].num === 0) {
          list.splice(index, 1)
          let allI = this.allIdList.indexOf(goods_id)
          this.allIdList.splice(allI, 1)
          //删除已选择物品
          if (checkedIdList.indexOf(goods_id) > -1) {
            checkedIdList.splice(checkedIdList.indexOf(goods_id), 1)
          }
        }
      }
    })

    goodStorage.decrement(goods_id)

    // setState({
    //   checkedIdList: checkedIdList,
    //   list: list,
    // })
    calculatedTotal(checkedIdList, list)
  }
  //清空购物袋中已经售罄的商品
  clearCar = async () => {
    const { depot_id } = this.props
    const { data } = await clearCarApi({ depot_id })
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    await this.getGoods(depot_id)
  }

  //计算总金额
  calculatedTotal = async (checkedIdList: Array<string>, list: Array<any>) => {

    let amount: any = 0
    this.buyinfo = []
    checkedIdList.forEach((id: string) => {
      list.forEach((good: any) => {
        if (good.goods_id === id) {
          amount = util.numAdd(
            amount,
            util.numMulti(good.num, good.current_price),
          )
          //两位小数
          amount = util.toDecimal2(amount)
          this.buyinfo.push({ id: good.id, goods_id: good.goods_id, num: good.num })
        }
      })
    })
    this.setState({
      totalAmount: amount,
    })
    //重新选择优惠券
    const { setCouponNoAction } = this.props
    await setCouponNoAction('')
  }

  //是否选择
  isChecked = (id: string) => {
    return this.state.checkedIdList.indexOf(id) >= 0
  }
  navFillOrder = async () => {
    if (this.state.checkedIdList.length === 0) {
      Toast.info('请选择要下单的商品', 1)
      return
    }
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('click_Cart_check', '')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Cart_check'})
    }
    sessionStorage.setItem('buyinfo', JSON.stringify(this.buyinfo))
    const { depot_id } = this.props
    this.props.history.push({ pathname: `/fillorder/prepare/new/${depot_id}` })
  }

  render() {
    const { isLoading } = this.state
    const list = this.state.list
    const listItems = list.map((item: any) => (
      <Item key={item.goods_id}>
        <div className="pro-item">
          {//半透明
            item.num === '0' && <div className="translucent" />}
          <Checkbox
            onChange={(bool: boolean) => {
              if (item.num !== '0') {
                this.checkChange(bool, item.goods_id)
              }
            }}
            checked={this.isChecked(item.goods_id)}
          />
          <Goods
            goods={item}
            decrease={this.decreaseGood}
            increase={this.increaseGood}
          />
        </div>
      </Item>
    ))

    let Content = (
      <div className="page">
        <div className="product-list">
          <label>
            <Item extra={<span style={{ color: '#f39800' }}>自提免运费</span>}>
              <div className="item">
                <Checkbox
                  checked={this.state.checkAll}
                  onChange={this.onCheckAllChange}
                />
                <img
                  className="logo"
                  src={
                    process.env.PUBLIC_URL +
                    '/assets/img/shopping_cart_logo.png'
                  }
                  alt="anxin.png"
                />
                <span className="anxintext">安歆公寓</span>
              </div>
            </Item>
          </label>
          {listItems}
          {list.length !== this.allIdList.length && (
            <div className="but">
              <Button
                style={{ width: '100%' }}
                onClick={() => {
                  this.clearCar()
                }}
              >
                清空售罄商品
              </Button>
            </div>
          )}
        </div>
      </div>
    )
    return (
      <div className="product-page">
        {
          isLoading
            ? <div className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10vw' }}>
              {
                // TODO: 骨架屏未实现
                <ActivityIndicator
                  text="加载中..."
                />
              }

              {/* <div className="title loading"></div>
              <div>
                <Item>
                  <div className="pro-item">
                    <div className="translucent" />
                    <Checkbox
                      checked={true}
                    />
                    <div className="shoping-goods">
                      <div className="img"></div>
                      <div className="text ">
                        <div

                          className="text-ell font-7 loading"
                        >
                          &nbsp;&nbsp;&nbsp;
                        </div>
                        <div

                          className="text-ell retail font-8 loading"
                        >
                          &nbsp;&nbsp;&nbsp;
                        </div>
                        <div className="add-delete font-8 loading">
                          &nbsp;&nbsp;&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </Item>
              </div> */}
            </div>
            : <React.Fragment>
              <APullToRefresh
                refreshing={this.state.refreshing}
                onRefresh={this.onRefresh}
                ref={(el: any) => (this.ptr = el)}
                style={{
                  height: `calc(100vh - ${this.state.height}px)`,
                  overflow: 'auto',
                }}
              >
                {list.length === 0 && <Empty />}
                {list.length !== 0 && Content}
              </APullToRefresh>

              <div
                className="navbar-bot"
                style={{
                  visibility: list.length === 0 ? 'hidden' : 'visible',
                }}
              >
                <label className="allcheck">
                  <Checkbox
                    checked={this.state.checkAll}
                    onChange={this.onCheckAllChange}
                  />
                  &nbsp; 全选
            </label>
                合计
            <span className="font_yellow">
                  &nbsp;￥{this.state.totalAmount}
                </span>
                {this.state.is_rest ? (
                  <div className="but-settl store-reast">
                    休息中 <i className="iconfont">&#xe60e;</i>
                  </div>
                ) : (
                    <div onClick={() => this.navFillOrder()} className="but-settl">
                      去结算 <i className="iconfont">&#xe60e;</i>
                    </div>
                  )}
              </div>
            </React.Fragment>
        }

      </div>
    )
  }
}

export default ProductList
